import React, {ReactElement, useContext} from "react";
import {IOpportunitySearchContext, OpportunitySearchContext,} from "../../context/OpportunitySearchContext";
import {Banner} from "../../components/Banner/Banner";
import {OpportunitySearchForm} from "../../components/OpportunitySearchForm/OpportunitySearchForm";
import {NoRecordFound} from "../../../NoRecordFound";
import {Col, Row} from "react-bootstrap";
import {OpportunityList} from "../../components/OpportunityList/OpportunityList";
import {OpportunityMap} from "../../components/OpportunityMap/OpportunityMap";
import {useMediaQuery} from "react-responsive";
import {Skeleton} from 'primereact/skeleton';

export interface ILandingLayoutProps {
}

export function LandingLayout(props: ILandingLayoutProps): ReactElement {
    const {loading, showNoDriveFound} = useContext<IOpportunitySearchContext>(
        OpportunitySearchContext,
    );
    const isMobile: boolean = useMediaQuery({maxWidth: 720});

    return (
        <>
            <Banner/>
            <OpportunitySearchForm/>
            {showNoDriveFound ? (
                loading ? (
                    isMobile ? (<Row className={"d-flex flex-grow-1 flex-row"}>
                            <Col xs={12} className="mobileMap">
                                <Skeleton height="100%"></Skeleton>
                            </Col>
                            <Col className={"d-flex flex-column"} xs={12}>
                                <Skeleton height="100%"></Skeleton>
                            </Col>

                        </Row>
                    ) : (
                        <Row className={"d-flex flex-grow-1 flex-row"}>
                            <Col className={"d-flex flex-column"} xs={6}>
                                <Skeleton height="170px"></Skeleton>
                            </Col>
                            <Col xs={6}>
                                <Skeleton height="100%"></Skeleton>
                            </Col>
                        </Row>
                    )) : (<NoRecordFound/>)
            ) : (
                isMobile ? (<Row className={"d-flex flex-grow-1 flex-row"}>
                        <Col xs={12} className="mobileMap">
                            <OpportunityMap/>
                        </Col>
                        <Col className={"d-flex flex-column"} xs={12}>
                            <OpportunityList/>
                        </Col>

                    </Row>
                ) : (
                    <Row className={"d-flex flex-grow-1 flex-row"}>

                        <Col className={"d-flex flex-column"} xs={6}>
                            <OpportunityList/>
                        </Col>
                        <Col xs={6}>
                            <OpportunityMap/>
                        </Col>
                    </Row>)
            )}
        </>
    );
}
